module.exports = __webpack_public_path__ + "img/22073160_m.83a04b94.jpg";